import React, { useState, useEffect, useRef} from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './EggCalculator.css';
// import jsPDF from 'jspdf';
import CalculatorReview from '../../components/CalculatorReview';
import { fetchAnimalTypeByCategoryId, fetchCalculatorReviewByReviewType, fetchSubBreedsByAnimalTypeId, produceCalculation } from '../../action/functions';
import { useSelector } from 'react-redux';
import ButtonFrame from '../../snippets/ButtonFrame';
import ToastMessage from '../../snippets/ToastMessage';
import SignInModal from '../../snippets/modal/SignInModal';
import SignUpModal from '../../snippets/modal/SignUpModal';
import useGoogleAnalytics from '../../action/useGoogleAnalytics';

const EggCalculator = () => {
  const trackEvent = useGoogleAnalytics("G-JKWGJ86LX7");

  const [loading, setLoading] = useState(false);
  const [minAge, setMinAge] = useState(16);
  const [formData, setFormData] = useState({
    animal_type : '0',
    breed_type : '0',
    produce_type : 1,
    min_age: 16,
    max_age : 50,
    total_animal: ''
  })
  const [animalType, setAnimalType] = useState(null);
  const [breedType, setBreedType] = useState(null);
  const [selectedBreed, setSelectedBreed] = useState(null);
  const [breedInput, setBreedInput] = useState('');
  const [openBreedSearch, setOpenBreedSearch] = useState(false);

  const [eggData, setEggData] = useState(null);
  const [activeTab, setActiveTab] = useState('egg');
  const [hasReviewed, setHasReviewed] = useState(false);

  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  
  const account = useSelector(state => state.account);
  const [isStartOpen, setIsStartOpen] = useState(true);
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const subBreedRef = useRef(null);


  const [msgAlert, setMsgAlert] = useState({
    active: false,
    message: "",
    status: "warning"
  });

    useEffect(() => {
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_title: "Egg Calculator",
          page_location: window.location.href,
          page_path: "/egg-calculator", 
        });
      }
    }, []);

  useEffect(() => {
    if (animalType) return;
    (async() => {
      let search_param = new URLSearchParams({
        produce: true
      });
      let search_param_obj = search_param.toString();

      let result = await fetchAnimalTypeByCategoryId(1, search_param_obj);

      if (!result.status) {

        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }
      setAnimalType([{
        id: "0",
        name: "Select Poultry Type",
        selected: true
      }, ...result.data.data]);

    })();
  }, [animalType]);

  useEffect(() => {
    if (!account || !account.isAuthenticated) return;

    (async() => {
      let result = await fetchCalculatorReviewByReviewType(account.token, 3);

      if (!result.status) {

        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }

      if (result.data.data.review.length > 0) {
        setHasReviewed(true);
      }else {
        setHasReviewed(false);
      }

    })();
  }, [account]);

  useEffect(() => {
    if (!openBreedSearch) return;

    document.onclick = (e) => {
      let target_value = e.target;

      if (subBreedRef.current && target_value !== subBreedRef.current) {
        if (target_value.tagName === 'INPUT' && target_value.id === 'breed') return;

        if (!subBreedRef.current.querySelector(`${target_value.tagName.toLowerCase()}.breed_child`)) {
          setOpenBreedSearch(false)
        }
      }
      console.log(e);
      console.log(subBreedRef);
    }
  }, [openBreedSearch]);

  useEffect(() => {
    if (activeTab === 'egg-result') {
      const timer = setTimeout(() => {
        if (hasReviewed) return;
        setIsRatingModalOpen(true);
      }, 30000); 
  
      return () => clearTimeout(timer);
    }
  }, [activeTab, hasReviewed]);
  
  const closeRatingModal = () => {
    setIsRatingModalOpen(false);
  }

  const handleFormChange = (evt, name) => {
    setFormData({...formData, [name]:evt.target.value});
  }

  const handleAnimalChange = async (evt) => {
    setSelectedBreed(null);
    setOpenBreedSearch(false);

    let animal_min_age = evt.target.selectedOptions[0].getAttribute('datatarget');
    setMinAge(animal_min_age);

    setFormData({...formData, min_age: parseInt(animal_min_age), breed_type: '0', animal_type: evt.target.value});

    // handleFormChange(evt, 'animal_type');


    let result = await fetchSubBreedsByAnimalTypeId(evt.target.value);
    
    if (!result.status) {

      setMsgAlert({
        active: true,
        message: result.message,
        status: "error"
      });
      return;
    }

    setBreedType([
      ...result.data.data
    ]);
  }

  const calculateEgg = async () => {
    if (!account || !account.isAuthenticated) return;
    
    if (formData.animal_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Poultry type is required',
        status: "warning"
      });
      return null;
    }

    if (formData.breed_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Breed is required',
        status: "warning"
      });
      return null;
    }

    if (parseInt(formData.min_age) < minAge) {
      setMsgAlert({
        active: true,
        message: 'Start Age must be greater than or equals to 16',
        status: "warning"
      });
      return null;
    }

    if (parseInt(formData.min_age) > 80) {
      setMsgAlert({
        active: true,
        message: 'Start Age must be lesser than or equals to 80',
        status: "warning"
      });
      return null;
    }

    if (parseInt(formData.max_age) < 16) {
      setMsgAlert({
        active: true,
        message: 'End Age must be greater than or equals to 16',
        status: "warning"
      });
      return null;
    }

    if (parseInt(formData.max_age) > 80) {
      setMsgAlert({
        active: true,
        message: 'End Age must be lesser than or equals to 80',
        status: "warning"
      });
      return null;
    }

    if (parseInt(formData.max_age) <= parseInt(formData.min_age)) {
      setMsgAlert({
        active: true,
        message: 'End Age must be greater than Start Age',
        status: "warning"
      });
      return null;
    }

    setLoading(true);
    let result = await produceCalculation(account.token, formData);

    if (result.status) {
      setEggData(result.data.data);
      setActiveTab('egg-result');
      trackEvent("egg_calculator_button");
    }else {

      setMsgAlert({
        active: true,
        message: result.message,
        status: "error"
      });
    }
    setLoading(false);
  };

  const handleBack = () => {
    setActiveTab('egg');
  };

  const openSignInModal = () => {
    setIsSignInModalOpen(true);
    setIsSignupModalOpen(false);
  };

  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };

  const openSignupModal = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(true);
  };

  const closeSignupModal = () => {
    setIsSignupModalOpen(false);
  };

  const getFormattedDate = () => {
    const today = new Date();
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return today.toLocaleDateString('en-GB', options).replace(',', '.');
  };


  // const downloadAsPDF = () => {
  //   const feedWatermark = document.querySelector('.watermark-image');
  //   const feedResultHeader = document.querySelector('.feed-result-header');
  //   const feedResultLogoHeader = document.querySelector('.feed-result-logo-header');
  //   const feedActionsBtn = document.querySelector('.feed-actions');
  //   const fetchSocial = document.querySelector('.feed-result-social-container');
  //   const fetchEdit = document.querySelector('.feed-edit-button');

  //   if (feedResultHeader && feedResultLogoHeader && (account && account.isAuthenticated)) {

  //     feedResultHeader.style.display = 'none';
  //     feedActionsBtn.style.display = 'none';
  //     fetchEdit.style.display = 'none';
  //     feedResultLogoHeader.style.display = 'flex';
  //     fetchSocial.style.display = 'flex';
  //     feedWatermark.style.display = 'flex';

  //     html2canvas(document.querySelector('.feed-result-container'), { scale: 2 }).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const imgWidth = 210; 
  //       const pageHeight = 297;
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       let yPosition = 10;

  //       if (imgHeight <= pageHeight) {
  //         pdf.addImage(imgData, 'PNG', 0, yPosition, imgWidth, imgHeight);
  //       } else {
  //         let remainingHeight = imgHeight;
  //         let srcY = 0; 

  //         while (remainingHeight > 0) {
  //           const cropHeight = Math.min(remainingHeight, pageHeight - 10);
  //           const croppedCanvas = document.createElement('canvas');
  //           croppedCanvas.width = canvas.width;
  //           croppedCanvas.height = (cropHeight * canvas.width) / imgWidth;

  //           const croppedCtx = croppedCanvas.getContext('2d');
  //           croppedCtx.drawImage(
  //             canvas,
  //             0,
  //             srcY,
  //             canvas.width,
  //             croppedCanvas.height,
  //             0,
  //             0,
  //             croppedCanvas.width,
  //             croppedCanvas.height
  //           );

  //           const croppedImg = croppedCanvas.toDataURL('image/png');
  //           pdf.addImage(croppedImg, 'PNG', 0, yPosition, imgWidth, cropHeight);

  //           remainingHeight -= cropHeight;
  //           srcY += croppedCanvas.height;

  //           if (remainingHeight > 0) {
  //             pdf.addPage();
  //           }
  //         }
  //       }

  //       pdf.save(`Feed result_${getFormattedDate()}_${account.fullname.split(" ")[0]}.pdf`);

  //       feedResultHeader.style.display = 'flex';
  //       feedActionsBtn.style.display = 'flex';
  //       fetchEdit.style.display = 'flex';
  //       feedResultLogoHeader.style.display = 'none';
  //       fetchSocial.style.display = 'none';
  //       feedWatermark.style.display = 'none';
  //     });
  //   }
  // };

  const handleBreedSearch = (val) => {
    if (!breedType) return;
    setBreedInput(val);
    setBreedType((prevBreedType) => (
      prevBreedType.filter((breed) => {
        if (breed.name.toLowerCase().includes(val.toLowerCase())) {
          breed.show = true;
        }else {
          breed.show = false;
        }
        return breed;
      })
    ));

  }

  useEffect(() => {
    if (activeTab === "egg-result") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activeTab]);


  return (
    <>
      <Navbar />
      {(!account || !account.isAuthenticated) && (
        <div className='email-popup-container'>
          <div className='check-email-popup'>
            <div className='email-popup-header'>
              <img src="/assets/carbon_email.svg" alt="Email Icon" className='email-popup-icon'/>
              <p className='email-popup-text'>Sign in / Sign up to use calculator</p>
            </div>
          </div>        
        </div>
      )}

      <div className="feed-calculator-container">
        <div className={`feed-calculator-header-container ${activeTab === 'egg-result' ? 'hidden' : ''}`}>
            <div className="feed-calculator-header">
              <img src="/assets/eggs_shell.png" alt="eggs"/>
              <h1>Egg Production Calculator</h1>
            </div>
            <p className='feed-header-desc-mobile'>Estimate how much eggs you can  generate from any number of poultry birds based on their age, breed etc.</p>

            <div className='feed-calculator-tabs-container'>
              <p>Estimate how much eggs you can  generate from any number of poultry birds based on their age, breed etc.</p>
            </div>
          </div>

        <div className='feed-calculator-result'>
          {activeTab === 'egg' && (
            <div className="feed-calculator-card egg-calculator-card">

              {/* Poultry Type */}
              <div className="feed-input-container egg-input-container">
                <select
                  id="poultry-type"
                  value={formData.animal_type}
                  onChange={(e) => handleAnimalChange(e)}
                >
                  {animalType && animalType.map((type) => (
                    <option key={type.id} value={type.id} datatarget={type.min_produce_age}>{type.name}</option>  
                  ))}
                </select>
                <img src='/assets/mingcute_down_gold.svg' alt="down"/>
              </div>
          
              {/* Breed Type */}
              <div className='search__container'>
                <div className="feed-input-container egg-input-container">
                  {!selectedBreed ? (
                    <input
                      type='text'
                      id="breed"
                      value={breedInput}
                      placeholder='Enter Breed'
                      onChange={(e) => handleBreedSearch(e.target.value)}
                      onFocus={() => setOpenBreedSearch(true)}
                    />
                  ): (
                    <div className='feed-input-div' onClick={() => { setSelectedBreed(null); setFormData({...formData, breed_type: "0"}) }}>
                      <p>{selectedBreed.name}</p>
                    </div>
                  )}
                  <img src='/assets/search-rounded.svg' alt="search" />
                </div>
                {breedType && openBreedSearch && (
                  <div ref={subBreedRef} className='feed-calculator-card egg-calculator-card search-card'>
                    {breedType.map((breed, index) => (
                      (breed.show === undefined || breed.show) && (
                        <button type='button' className='breed_child' onClick={() => { setSelectedBreed(breed); setOpenBreedSearch(false); setFormData({...formData, breed_type: breed.id}) }} key={index}>{breed.name}</button>
                      )
                    ))}
                  </div>
                )}
              </div>
          
              {/* Birds Count */}
              <div className="feed-input-container egg-input-container">
                <label htmlFor="bird-count">How many layer(s)?</label>
                <input
                  type="number"
                  id="birds-count"
                  value={formData.total_animal}
                  placeholder='0'
                  min={0}
                  onChange={(e) => handleFormChange(e, 'total_animal')}
                  onFocus={(e) => { e.target.placeholder = ''}}
                  onBlur={(e) => { e.target.placeholder = '0' }}
                  required
                />
              </div>
              {isStartOpen && (
                <div className='start-age-content'>
                  <div className='start-title-container'>
                    <h3 className='egg-start-end-title'>Start/End Age</h3>
                    <img src='/assets/close_gold.png' alt='close icon' className='start-close-icon' onClick={() => setIsStartOpen(false)}/>
                  </div>
                  <div className='start-age-container'>
                    <p className='start-end-age-text'><strong>Start Age:</strong> The age you wish to start tracking egg production.</p>
                    <p className='start-end-age-text'><strong>End Age:</strong> The age you wish to stop tracking egg production.</p>
                  </div>
                </div>
              )}
          
              {/*Start and End date*/}
              <div className="feed-inputs-container">
                <div className="feed-input-container">
                  <div className='feed-label-wrapper'>
                    <label>Start Age (Weeks)</label>
                    {/* <img src="/assets/question-fill.png" alt="question mark" className='feed-question-mark'/> */}
                  </div>
                  <div className="feed-input-wrapper egg-input-container">
                    <input
                      type="number"
                      id="start-age"
                      value={formData.min_age}
                      min={minAge}
                      onChange={(e) => handleFormChange(e, 'min_age')}
                      required
                    />
                    <span className="feed-unit">wk</span>
                  </div>
                </div>
          
                <div className="feed-input-container">
                  <div className='feed-label-wrapper'>
                    <label>End Age (Weeks)</label>
                    {/* <img src="/assets/question-fill.png" alt="question mark" className='feed-question-mark'/> */}
                  </div>
                  <div className="feed-input-wrapper egg-input-container">
                    <input
                      type="number"
                      id="end-date"
                      value={formData.max_age}
                      min={minAge}
                      onChange={(e) => handleFormChange(e, 'max_age')}
                      required
                    />
                    <span className="feed-unit">wk</span>
                  </div>
                </div>
              </div>
              {account && account.isAuthenticated ? (
                <ButtonFrame handleClick={calculateEgg} loading={loading} btnText={"Calculate"} classNameStyle="feed-calculate-btn" />
              ): (
                <ButtonFrame handleClick={() => openSignInModal()} loading={loading} btnText={"Login to access calculator"} classNameStyle="feed-calculate-btn" />
              )}
            </div>
          )}

          {activeTab === 'egg-result' && (
            <div className="feed-result-container">
              {/* Header */}
              <header className="feed-result-header">
                <img src="/assets/form-next.png" alt="next arrow" className="feed-back-button" onClick={handleBack}/>
                <h1>Egg Result</h1>
                <img src="/assets/send_icon.svg" alt="send icon" className="feed-send-button"/>
              </header>

              <header className="feed-result-logo-header">
                <img src="/assets/rairer-logo.svg" alt="raier logo" className="feed-result-logo"/>
                <div className='feed-date-container'>
                  <h4>Egg Projections</h4>
                  <p>{getFormattedDate()}</p>
                </div>
              </header>

              {/* Chicken Details */}
              <div className="feed-bird-card">
                <div className="feed-card-header">
                  <div className='feed-icon-wrapper-container'>
                    <div className="feed-icon-wrapper">
                      <img src="/assets/chicken.png" alt="Chicken Icon" />
                    </div>
                    <h2>{formData.total_animal} {eggData.produce.breed}</h2>
                  </div>
                  <button className="feed-edit-button" onClick={handleBack}>Edit</button>
                </div>

                <div className="feed-card-body">
                  <div className='feed-info-container'>
                    <img src="/assets/rearing-duration.png" alt="feather" className='feed-info-img'/>
                    <div className="feed-info">
                      <span className="feed-info-label">Start/End Age</span>
                      <p>Week {formData.min_age} - Week {formData.max_age}</p>
                    </div>
                  </div>
                  <div className='feed-info-container'>
                    <img src="/assets/duration.svg" alt="duration icon" className='feed-info-img'/>
                    <div className="feed-info">
                      <span className="feed-info-label">Duration</span>
                      <p>{Math.floor(eggData.produce_breakdown.laying_duration_in_weeks / 4)}{eggData.produce_breakdown.laying_duration_in_weeks % 4 > 0 && `.${eggData.produce_breakdown.laying_duration_in_weeks % 4}`} Month<span style={{fontSize:"9px"}}>(s)</span></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* egg Estimate */}
              <div className="feed-card feed-estimate-card">
                <div className="feed-title-header">
                  <img src="/assets/egg_estimate.png" alt="egg Icon"/>
                  <h2>Egg Estimate</h2>
                </div>
                <div className='feed-card-divider'></div>

                <div className="feed-estimate-body">
                    <div className='feed-item-container'>
                      <div className="feed-item">
                        <p className="feed-item-title">Egg Per Bird</p>
                        <div className='feed-meta'>
                          <p className="feed-duration spanned">{parseInt(eggData.produce_breakdown.min_produce_per_bird_per_week)} - {parseInt(eggData.produce_breakdown.max_produce_per_bird_per_week)} Eggs (Weekly)</p>
                        </div>

                        <div className='feed-meta' style={{marginTop:"10px"}}>
                          <p className="feed-duration spanned">{eggData.produce_breakdown.total_lay_per_bird} - {eggData.produce_breakdown.total_lay_per_bird_max} Eggs ({Math.floor(eggData.produce_breakdown.laying_duration_in_weeks / 4)}{eggData.produce_breakdown.laying_duration_in_weeks % 4 > 0 && `.${eggData.produce_breakdown.laying_duration_in_weeks % 4}`} Month<span style={{fontSize:"9px"}}>(s)</span>)</p>
                        </div>
                      </div>
                    </div>

                    {/* <div className='feed-item-container'>
                      <div className="feed-item">
                        <p className="feed-item-title">Eggs Per Bird ({Math.floor(eggData.produce_breakdown.laying_duration_in_weeks / 4)} Month<span className='feed-item-title' style={{fontSize:"9px"}}>(s)</span> <sub className='feed-duration'>{eggData.produce_breakdown.laying_duration_in_weeks % 4 > 0 && `${eggData.produce_breakdown.laying_duration_in_weeks % 4}`} Week<span style={{fontSize:"9px"}}>(s)</span></sub>)</p>

                        <div className='feed-meta'>
                          <p className="feed-duration spanned">{eggData.produce_breakdown.total_lay_per_bird} - {eggData.produce_breakdown.total_lay_per_bird_max} Eggs</p>
                        </div>
                      </div>
                    </div> */}
                </div>

                <div className='feed-card-divider'></div>

                <div className='feed-estimate-body space-estimate-body'>
                  <div className='total-estimate'><p>Total Estimate</p></div>
                </div>
                
                <div className='feed-estimate-body space-estimate-body'>
                  <p className='egg-item-title'>{parseFloat(eggData.produce_breakdown.total_estimate).toLocaleString()} - {parseFloat(eggData.produce_breakdown.total_estimate_max).toLocaleString()} Eggs</p>
                </div>
                <div className='feed-card-divider'></div>
                <p className='feed-note'><span className='feed-note-heading'>Note:</span> Most commercial layers lay an egg every 26–28 hours 
                  under optimal conditions. Estimates may vary slightly 
                  depending on specific breeds, feed quality, and poultry farm management. 
                </p>
                <img src='/assets/rairer-calculator-watermark.svg' alt="watermark" className='watermark-image'/>
              </div>

              <div className='feed-result-social-container'>
                <p>@rairerapp</p>
                <div className='feed-social-container'>
                  <img src='/assets/facebook-color.svg' alt='Facebook Icon'/>
                  <img src='/assets/twitter-color.svg' alt='Twitter Icon'/>
                  <img src='/assets/instagram-color.svg' alt='Instagram Icon'/>
                  <img src='/assets/linkedin-color.svg' alt='LinkedIn Icon'/>
                </div>
              </div>

                {/* Download btn */}
                {/* <div className='feed-actions' onClick={downloadAsPDF}>
                  <div className='feed-action-btn-container'>
                    <img src="/assets/download-outline.png" alt="download icon"/>
                    <button className="feed-action-button" onClick={downloadAsPDF}>Download</button>
                  </div>
                </div> */}

            </div>
          )}
        </div>
      </div>
      <Footer/>
      {(account && account.isAuthenticated) && isRatingModalOpen && (
        <CalculatorReview account={account} reviewType={{
          id: 3,
          name: "Egg"
        }} closeRatingModal={closeRatingModal}/>
      )}

      {isSignInModalOpen && (
        <SignInModal closeSignIn={closeSignInModal} openSignUp={openSignupModal} onSubmit={closeSignInModal}  />
      )}

      {isSignupModalOpen && (
        <SignUpModal closeSignup={closeSignupModal} openSignIn={openSignInModal} onSubmit={closeSignupModal} />
      )}

      {msgAlert.active && <ToastMessage toastTitle={"Feed Calculator"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({...msgAlert, active:false})} />}
    </>
  );
};

export default EggCalculator;
